import CASL from '@/utils/constants/casl'

export default {
  path: 'dealer-library',
  children: [
    {
      path: '',
      name: 'dealer-library.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.DEALER
      },
      component: () => import('./list/DealerLibraryListPage.vue')
    }
  ]
}
